import { useState, useEffect } from "react";
import TableContainer from "../../Containers/RecordingsManagement/TableContainer/TableContainer";
import { retrieveCallRecordingInfo } from "../../Services/HeedifyServices";
import "./RecordingComponent.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
export default function RecordingComponent(props) {
  const { t } = useTranslation();
  const [filteredRecordings, setFilteredRecordings] = useState([]);
  
  // Get all callflows from Redux
  const allCallFlows = useSelector(state => state.reducer.CALL_FLOWS) || {};
  
  // Get tenantId from props or global context
  const tenantId = props.tenantId;
  // Default columns configuration
  const getDefaultColumns = () => [
    { key: "audio", labelKey: "RECORDING", visible: true },
    { key: "direction", labelKey: "DIRECTION", visible: true },
    { key: "recordingScope", labelKey: "RECORDING_SCOPE", visible: true },
    { key: "callerId", labelKey: "CALLER_ID", visible: true },
    { key: "duration", labelKey: "DURATION", visible: true },
    { key: "agentName", labelKey: "AGENT_NAME", visible: true },
    { key: "date", labelKey: "DATE", visible: true },
    { key: "transcription", labelKey: "TRANSCRIPTION", visible: true },
    { key: "callId", labelKey: "CALL_ID", visible: true },
  ];

  // Load columns from localStorage or use default
  const loadColumns = () => {
    const savedColumns = localStorage.getItem("recordingTableColumns");
    return savedColumns ? JSON.parse(savedColumns) : getDefaultColumns();
  };

  const [columns, setColumns] = useState(loadColumns);

  // Save columns to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("recordingTableColumns", JSON.stringify(columns));
  }, [columns]);

  const handleColumnsChange = (newColumns) => {
    setColumns(newColumns);
  };

  // Get date range from today to one month back
  const getCurrentMonthDateRange = () => {
    const now = new Date();
    
    // Today's date at 23:59:59.999 in local time (end)
    const endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    
    // One month back at midnight in local time (start)
    const startDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate(), 0, 0, 0, 0);
    
    return { startDate: startDate.getTime(), endDate: endDate.getTime() };
  };

  // Initialize filters with current month date range
  const [filters, setFilters] = useState({
    direction: "",
    recordingScope: [], 
    callerId: "",
    agentName: "",
    callId: "",
    duration: { Min: "", Max: "" },
    date: { startDate: getCurrentMonthDateRange().startDate, endDate: getCurrentMonthDateRange().endDate },
  });

  // Function to update filters
  const onFilterChange = (updatedFilters) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      ...updatedFilters,
    }));
  };
  
  // Helper function to convert callflows data to array
  const getCallFlowsArray = () => {
    if (!allCallFlows) return [];
    if (Array.isArray(allCallFlows)) return allCallFlows;
    return Object.values(allCallFlows);
  };
  
  // Update recordingScope - initialize with ALL callflows + agents by default
  useEffect(() => {
    // Get all callflow IDs from Redux
    const callFlowsArray = getCallFlowsArray();
    const allCallFlowIds = callFlowsArray.map(flow => flow.id).filter(id => id);
    
    const combinedIds = [
      ...new Set([
        ...allCallFlowIds, // All callflows from Redux
        ...(Array.isArray(props.supervisedAgentIds) ? props.supervisedAgentIds : [])
      ])
    ];
    
    // Always set to combined IDs (all scopes selected by default)
    setFilters((prevFilters) => ({
      ...prevFilters,
      recordingScope: combinedIds,
    }));
  }, [allCallFlows, props.supervisedAgentIds]);

  // Call the service with filters to retrieve data
  useEffect(() => {
    if (filters.recordingScope.length > 0 && tenantId) {
      retrieveCallRecordingInfo(tenantId, filters)
        .then((data) => {
          setFilteredRecordings(data);
        })
        .catch((error) => {
          console.error("Error retrieving recordings:", error);
          setFilteredRecordings([]);
        });
    }
  }, [filters, tenantId]); 

  return (
    <div className="recording-container">
      <h2>{t("RECORDINGS")}</h2>
      <TableContainer
        data={filteredRecordings}
        onFilterChange={onFilterChange}
        filters={filters}
        columns={columns}
        onColumnsChange={handleColumnsChange}
        allCallFlows={allCallFlows}
      />
    </div>
  );
}
